/**
 * The project tab strip (APP_SPEC): sibling screens under one project
 * param. The shell owns it -- modules never link to each other; the
 * URL (params AND the filter search) carries across tabs. A Segment
 * whose selection navigates: the look is the strata's, the navigation
 * the router's.
 */
import { useNavigate } from '@tanstack/react-router';
import { Segment } from '../strata';

const TABS = [
  { key: 'viewer', label: 'Viewer', to: '/projects/$projectId' },
  { key: 'takeoff', label: 'Takeoff', to: '/projects/$projectId/takeoff' },
  { key: 'review', label: 'Review', to: '/projects/$projectId/review' },
] as const;

export type ProjectTab = (typeof TABS)[number]['key'];

export function ProjectTabs({ projectId, active }: { projectId: string; active: ProjectTab }) {
  const navigate = useNavigate();
  return (
    <nav aria-label="Project screens">
      <Segment
        size="sm"
        selectionMode="single"
        disallowEmptySelection
        selectedKeys={[active]}
        onSelectionChange={(keys) => {
          const key = Array.from(keys)[0] as ProjectTab | undefined;
          const tab = TABS.find((t) => t.key === key);
          if (tab && tab.key !== active)
            void navigate({ to: tab.to, params: { projectId }, search: (prev: Record<string, unknown>) => prev });
        }}
        options={TABS.map((tab) => ({ key: tab.key, label: tab.label }))}
      />
    </nav>
  );
}
